export const loginService = async (data) => {
  const URL = `/access/login`;
  const requestSetup = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const checkAuthentication = async () => {
  const URL = `/access/checking`;  
  const requestSetup = {
    method: "GET",
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const getAllCredentialService = async () => {
  const URL = `/access/credentials/all`;  
  const requestSetup = {
    method: "GET",
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const createUserService = async (data) => {
  const URL = `/access/credentials/create`;
  const requestSetup = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json", 
    },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const updatePasswordService = async (data) => {
  const URL = `/access/credentials/update`;
  const requestSetup = {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json", 
    },
    body: JSON.stringify(data)
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const resetPasswordService = async (id) => {
  const URL = `/access/credentials/reset/${id}`;
  const requestSetup = {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json", 
    },
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const removeCredentialService = async (id) => {
  const URL = `/access/user/remove/${id}`;
  const requestSetup = {
    method: "DELETE",
    headers: { 
      "Content-Type": "application/json", 
    },
  };
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const updateUserService = async (userId, data) => {
  const URL = `/access/user/update/${userId}`;
  const requestSetup = {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json", 
    },
    body: JSON.stringify(data)
  }
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const updateCredentialRoleService = async (credentialRoleId, data) => {
  const URL = `/access/credentials/role/update/${credentialRoleId}`;
  const requestSetup = {
    method: "PUT",
    headers: { 
      "Content-Type": "application/json", 
    },
    body: JSON.stringify(data)
  }
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}

export const clearCookies = async () => {  
  const URL = `/access/credentials/cookies/remove`;
  const requestSetup = {
    method: "GET",
    headers: { 
      "Content-Type": "application/json", 
    },
  }
  const query = await fetch(URL, requestSetup);
  const jsonData = await query.json();
  return jsonData;
}